import { useSelector } from "react-redux";
import { useGet, usePost } from "src/http-clients/clients";
import { getActiveStoreId } from "src/redux/selectors/app";

export const useCreateTaxes = () => {
  const activeStore = useSelector(getActiveStoreId);
  return usePost(`/users/stores/${activeStore}/taxes`);
};

export const useGetTaxes = () => {
  const activeStore = useSelector(getActiveStoreId);
  return useGet(`/users/stores/${activeStore}/taxes`);
};
